import React, { Component, Fragment } from "react";
import { Button, Container, Dropdown, Image } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router-dom";
import dollar from "../../../assets/images/icon-dollar-small.svg";
import ImgFilter from "../../../assets/images/icon-filter.svg";
import Spinner from "../../../components/UI/Spinner/Spinner";
import { logFirebaseEvent } from "../../../shared/utility";
import * as actions from "../../../store/actions/index.js";
import MyBill from "./MyBill/MyBill";
import MyBillProgress from "./MyBill/MyBillProgress/MyBillProgress";
import MyBillSummary from "./MyBill/MyBillSummary/MyBillSummary";
import classes from "./MyBills.module.css";


interface IParentProps {}
interface IStateFromProps {
  loadingBalanceBillingHistoryForUser: boolean;
  errorBalanceBillingHistoryForUser: boolean;
  balanceBillingHistoryForUser: {
    claimId: number;
    procedureLabel: string;
    patientName: string;
    dateOfService: string;
    facility: string;
    added: string;
    status: string;
    document: string;
  }[];
  myBillView: string;
  t: any;
}
interface IDispatchFromProps {
  onFetchBalanceBillingHistoryForUser: (userId: string, status: string) => void;
  onFetchDocumentTypes: (userId: string) => void;
  onRemoveExplanationOfBenefitsFiles: (fileArray: File[]) => void;
  onRemoveProviderBillsFiles: (fileArray: File[]) => void;
  onRemovePatientsResponsibilityFiles: (fileArray: File[]) => void;
  onResetDisputeAuthorizationFile: () => void;
  onResetBBClaimDetails: () => void;
  onResetDocumentTypes: () => void;
  onSetMyBillViewState: (myBillView) => void;
}
type Props = IParentProps &
  IStateFromProps &
  IDispatchFromProps &
  RouteComponentProps;
class MyBills extends Component<Props> {
  state = {
    summaryView: false,
    listView: true,
    progressView: false,
    claimId: 0,
    filter: "All",
    procedureLabel: "",
    patientName: "",
  };
  componentDidMount() {
    logFirebaseEvent("BalanceBillList");
    if (this.props.myBillView === "myBillList") {
      this.setState({ listView: true });
    }
    this.props.onFetchDocumentTypes(localStorage.getItem("userId")!);
    this.props.onFetchBalanceBillingHistoryForUser(
      localStorage.getItem("userId")!,
      "All"
    );
  }
  componentDidUpdate(prevProps) {
    if (prevProps.myBillView !== this.props.myBillView) {
      if (this.props.myBillView === "myBillList") {
        console.log("setting prevProps.myBillView", prevProps.myBillView);
        console.log("setting this.props.myBillView", this.props.myBillView);
        this.setState({ listView: true });
      }
    }
  }
  applyFilterHandler = () => {
    console.log(" this.state.filter", this.state.filter);
    this.props.onFetchBalanceBillingHistoryForUser(
      localStorage.getItem("userId")!,
      this.state.filter
    );
  };
  billClickedHandler = (
    claimId: number,
    procedureLabel: string,
    patientName: string
  ) => {
    this.props.onResetBBClaimDetails();
    this.props.onSetMyBillViewState("");
    // this.props.onResetDocumentTypes();
    this.setState({ claimId: claimId });
    this.setState({ procedureLabel: procedureLabel });
    this.setState({ patientName: patientName });
    this.setState({ summaryView: true });
    this.setState({ listView: false });
    this.setState({ progressView: false });
  };
  backToSummary = () => {
    this.setState({ summaryView: true });
    this.setState({ listView: false });
    this.setState({ progressView: false });
  };
  backToListClickedHandler = () => {
    this.setState({ listView: true });
    this.setState({ summaryView: false });
    this.setState({ progressView: false });
  };
  viewProgressClickHandler = () => {
    this.setState({ progressView: true });
    this.setState({ listView: false });
    this.setState({ summaryView: false });
  };
  onDropdownChangeHandler = (event) => {
    console.log(
      `event.target.checked ${event.target.id} ${event.target.checked}`
    );
    switch (event.target.id) {
      case "allFilter":
        this.setState({ filter: "All" });
        break;
      case "inProgressFilter":
        this.setState({ filter: "In progress" });
        break;
      case "closedFilter":
        this.setState({ filter: "Closed" });
        break;
    }
  };
  handleActionChange = (e) => {};
  render() {
    const { t } = this.props;
    // const elementLabelStyle = {
    //   fontSize: "13px",
    //   fontWeight: "600",
    //   color: "#117093",
    //   marginBottom: "3px",
    // };

    // const elementInputStyle = {
    //   margin: "0",
    //   fontSize: "12px",
    //   padding: "4px 10px",
    //   minHeight: "28px",
    //   borderRadius: "3px",
    //   minWidth: "100px",
    // };
    let spinner: any;
    if (this.props.loadingBalanceBillingHistoryForUser) {
      spinner = <Spinner />;
    }
    let billsAvailable: any;
    if (
      !this.props.loadingBalanceBillingHistoryForUser &&
      (this.props.errorBalanceBillingHistoryForUser ||
        !this.props.balanceBillingHistoryForUser ||
        this.props.balanceBillingHistoryForUser.length <= 0)
    ) {
      billsAvailable = (
        <div className="no-data">
          <div className="no-data-msg">{t("balanceBilling.noBills")}</div>
        </div>
      );
    } else {
      billsAvailable = this.props.balanceBillingHistoryForUser.map(
        (balanceBillHistory, index) => (
          <MyBill
            t={t}
            key={`${balanceBillHistory.patientName}${index}`}
            onBillClick={() =>
              this.billClickedHandler(
                balanceBillHistory.claimId,
                balanceBillHistory.procedureLabel,
                balanceBillHistory.patientName
              )
            }
            balanceBillHistory={balanceBillHistory}
          />
        )
      );
    }

    const filterDropDown = (
      <Dropdown className={classes.filterMore}>
        <Dropdown.Toggle
          id="dropdown-basic"
          className="btn btn-small btnFilter"
          // disabled={
          // !this.props.balanceBillingHistoryForUser ||
          // (this.props.balanceBillingHistoryForUser &&
          //   this.props.balanceBillingHistoryForUser.length <= 0)
          // }
          disabled={false}
        >
          {t("balanceBilling.filter")}
          <Image src={ImgFilter} alt="ImgFilter" />
        </Dropdown.Toggle>
        <Dropdown.Menu className={classes.filterDropdown}>
          <div className={classes.filterList}>
            <label>
              <input
                type="radio"
                id="allFilter"
                name="Filter"
                onChange={(e) => this.onDropdownChangeHandler(e)}
                checked={this.state.filter === "All"}
              />
              <span>{t("balanceBilling.all")}</span>
            </label>
            <label>
              <input
                type="radio"
                id="inProgressFilter"
                name="Filter"
                onChange={(e) => this.onDropdownChangeHandler(e)}
                checked={this.state.filter === "In progress"}
              />
              <span>{t("balanceBilling.inProgress")}</span>
            </label>
            <label>
              <input
                type="radio"
                id="closedFilter"
                name="Filter"
                onChange={(e) => this.onDropdownChangeHandler(e)}
                checked={this.state.filter === "Closed"}
              />
              <span>{t("balanceBilling.closed")}</span>
            </label>
          </div>
          <Dropdown.Item className={classes.dropdownStyle}>
            <Button
              className="btn-small btn-block"
              onClick={this.applyFilterHandler}
            >
              {" "}
              {t("balanceBilling.apply")}{" "}
            </Button>
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    );

    let myBill: any;
    if (this.state.summaryView) {
      myBill = (
        <MyBillSummary
          t={t}
          claimId={this.state.claimId}
          onBackToListClick={this.backToListClickedHandler}
          onViewProgressClick={this.viewProgressClickHandler}
        />
      );
    } else if (this.state.progressView) {
      myBill = (
        <MyBillProgress
          t={t}
          claimId={this.state.claimId}
          procedureLabel={this.state.procedureLabel}
          patientName={this.state.patientName}
          onBackClick={this.backToSummary}
        />
      );
    } else if (this.state.listView) {
      myBill = (
        <Container fluid>
          <div className="inner-banner">
            <div className="inner-banner-title">
              <h3>{t("balanceBilling.balanceBilling")}</h3>
              <Image src={dollar} alt="stock-image" data-test="stockIMG" />
            </div>
          </div>
          <div className={classes.titleLeft}>
            <h6 className="bill-heading">{t("balanceBilling.subTitle")}</h6>
          </div>
          {filterDropDown}
          <div className="clear"></div>
          {billsAvailable}
        </Container>
      );
    } else {
      myBill = (
        <div className="no-data">
          <div className="no-data-msg">{t("balanceBilling.noBills")}</div>
        </div>
      );
    }

    return (
      <Fragment>
        {spinner}
        {myBill}
      </Fragment>
    );
  }
}

const mapStateToProps = (state: any) => ({
  loadingBalanceBillingHistoryForUser:
    state.fetchBalanceBillingHistoryForUser.loading,
  errorBalanceBillingHistoryForUser:
    state.fetchBalanceBillingHistoryForUser.error,
  balanceBillingHistoryForUser:
    state.fetchBalanceBillingHistoryForUser.balanceBillingHistoryForUser,
  myBillView: state.setBalanceBillViewState.myBillView,
});
const mapDispatchToProps = (dispatch): IDispatchFromProps => ({
  onFetchBalanceBillingHistoryForUser: (userId, status) =>
    dispatch(actions.fetchBalanceBillingHistoryForUser(userId, status)),
  onFetchDocumentTypes: (userId) =>
    dispatch(actions.fetchDocumentTypes(userId)),
  onRemoveExplanationOfBenefitsFiles: (explanationOfBenefitsBills) =>
    dispatch(actions.explanationOfBenefitsBills(explanationOfBenefitsBills)),
  onRemoveProviderBillsFiles: (providerBills) =>
    dispatch(actions.providerBills(providerBills)),
  onRemovePatientsResponsibilityFiles: (patientsResponsibilityBills) =>
    dispatch(actions.patientsResponsibilityBills(patientsResponsibilityBills)),
  onResetDisputeAuthorizationFile: () =>
    dispatch(actions.resetDisputeAuthorizationFile()),
  onResetBBClaimDetails: () => dispatch(actions.resetBBClaimDetails()),
  onResetDocumentTypes: () => dispatch(actions.resetDocumentTypes()),
  onSetMyBillViewState: (myBillView) =>
    dispatch(actions.setMyBillViewState(myBillView)),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(withRouter(MyBills)));
